<template>
  <div>
    <div
      :id="`itemexpander-${item.jsonid}`"
      :ref="`itemexpander-${item.jsonid}`"
      class="voucher-item-main"
    >
      <div class="voucher-item-title">
        <span class="voucher-tour-icon" v-html="returnHeadingIcon" />
        <div class="voucher-item-title-container">
          <span>{{
            item.tour_details && item.tour_details.tour_style
              ? item.tour_details.tour_style.toUpperCase()
              : item.tourtype
              ? item.tourtype.toUpperCase()
              : item.jsontype.toUpperCase()
          }}</span>
          <!-- This will be hidden on desktop -->
          <h6 class="voucher-item-title-mobile">
            {{ item.operator }}
          </h6>
        </div>
      </div>

      <!-- This will be hidden on mobile devices -->
      <div class="voucher-item-main-desktop">
        <h6>
          {{
            item.suppliername
              ? item.suppliername
              : item.operator
              ? item.operator
              : ""
          }}
        </h6>
      </div>
      <div class="voucher-item-main-desktop">
        <ViewVoucherButton
          v-if="getParam === 'viewTFVoucher'"
          :type="'tf'"
          :vouchno="item.vouchno"
          @open-voucher="openVoucher('tf', item.vouchno, null)"
        />

        <ViewVoucherButton
          v-if="getParam === 'viewBedsOnlineVoucher'"
          :type="'bedsonline'"
          :vouchno="item.vouchno"
          @open-voucher="openVoucher('bedsonline', item.vouchno, null)"
        />

        <ViewVoucherButton
          v-if="getParam === 'viewViatorVoucher'"
          :type="'viator'"
          :vouchno="item.vouchno"
          @open-voucher="openVoucher('viator', item.vouchno, null)"
        />

        <ViewVoucherButton
          v-if="getParam === 'viewVoucher'"
          :type="'supplier'"
          :vouchno="item.vouchno"
          @open-voucher="
            openVoucher('supplier', item.vouchno, item.supdocslist[0])
          "
        />

        <button
          v-if="getParam === 'scrollToAdditionalDocs'"
          class="voucher-extra-info button voucher-btn"
          @click="$emit('scrollToAdditionalDocs', 'something')"
        >
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
          ><span>View Voucher</span>
        </button>

        <button
          v-else-if="getParam === 'viewMultiple'"
          class="voucher-extra-info button voucher-btn"
          @click="openMultipleVouchers()"
        >
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
          ><span>View Vouchers</span>
        </button>

        <button
          v-else-if="getParam === 'viewVoucherInfo'"
          class="voucher-extra-info button voucher-btn"
          @click="openNewVoucherModal(item.tfvouch_status)"
        >
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
          ><span>Voucher Information</span>
        </button>

        <button
          v-else-if="getParam === 'viewEssentialInfo'"
          class="voucher-extra-info button voucher-btn"
          @click="openEssentialInfo()"
        >
          <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
          ><span>Voucher Information</span>
        </button>
      </div>
    </div>
    <!-- This will be hidden on desktop -->
    <div class="voucher-item-main-mobile">
      <ViewVoucherButton
        v-if="getParam === 'viewTFVoucher'"
        :type="'tf'"
        :vouchno="item.vouchno"
        @open-voucher="openVoucher('tf', item.vouchno, null)"
      />

      <ViewVoucherButton
        v-if="getParam === 'viewBedsOnlineVoucher'"
        :type="'bedsonline'"
        :vouchno="item.vouchno"
        @open-voucher="openVoucher('bedsonline', item.vouchno, null)"
      />

      <ViewVoucherButton
        v-if="getParam === 'viewViatorVoucher'"
        :type="'viator'"
        :vouchno="item.vouchno"
        @open-voucher="openVoucher('viator', item.vouchno, null)"
      />

      <ViewVoucherButton
        v-if="getParam === 'viewVoucher'"
        :type="'supplier'"
        :vouchno="item.vouchno"
        @open-voucher="
          openVoucher('supplier', item.vouchno, item.supdocslist[0])
        "
      />

      <button
        v-if="getParam === 'scrollToAdditionalDocs'"
        class="voucher-extra-info button voucher-btn"
        @click="$emit('scrollToAdditionalDocs')"
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
        ><span>View Voucher</span>
      </button>

      <button
        v-else-if="getParam === 'viewMultiple'"
        class="voucher-extra-info button voucher-btn"
        @click="openMultipleVouchers()"
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
        ><span>View Vouchers</span>
      </button>

      <button
        v-else-if="getParam === 'viewVoucherInfo'"
        class="voucher-extra-info button voucher-btn"
        @click="openNewVoucherModal(item.tfvouch_status)"
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
        ><span>Voucher Information</span>
      </button>

      <button
        v-else-if="getParam === 'viewEssentialInfo'"
        class="voucher-extra-info button voucher-btn"
        @click="openEssentialInfo()"
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
        ><span>Voucher Information</span>
      </button>
    </div>

    <div v-if="dropdown">
      <div v-if="getParam === 'viewMultiple'">
        <div
          class="row align-items-center mb-3"
          v-for="filename in filenames"
          :key="filename"
        >
          <div class="col-md-1 vtd-py-2">Name:</div>
          <div class="col-md-8 text-none vtd-py-2">
            <strong class="ng-binding">{{ filename | replaceFilename }}</strong>
          </div>
          <div class="col-md-3">
            <a
              target="_blank"
              :href="
                'https://www.trailfinders.' +
                booking.booking_information.booking_site +
                '/tourdoc/bybookno/' +
                booking.user_information.bookingNumber +
                '/' +
                filename
              "
            >
              <button
                class="btn btn-support btn-consultant m-auto btn-secondary"
              >
                <i class="material-icons">&#xE880;</i>View Document
              </button>
            </a>
          </div>
        </div>
      </div>
      <div v-if="getParam === 'viewEssentialInfo'">
        <div v-if="voucherSuppliers.length > 0">
          <div
            v-for="(infoType, i) of voucherSuppliers"
            :key="i"
            class="item-container"
          >
            <div
              v-for="(item, index) of voucherSuppliers[i].cardImage"
              :key="index"
            >
              <b-collapse
                id="voucherCard"
                accordion="voucher-accordion"
                role="tabpanel"
              >
                <div class="item-dropdown accordions">
                  <div class="item-dropdown-main accordions-main">
                    <div class="extra-info-essentials">
                      <div class="dropdown-item-title">
                        <p>{{ item.title }}</p>
                      </div>
                      <div>
                        <p v-html="item.content"></p>
                      </div>
                      <div v-if="item.base64image" class="extra-info-img">
                        <img
                          class="non-gallery-img"
                          :src="item.base64image"
                          alt="accordion image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
              <b-collapse
                v-if="infoType.suppliers.length > 0"
                :id="'cardImage' + index"
                :visible="voucherSuppliers.length <= 1"
                accordion="voucher-accordion"
                role="tabpanel"
              >
                <div class="item-dropdown accordions">
                  <div class="item-dropdown-main accordions-main">
                    <div class="extra-info-essentials">
                      <div class="dropdown-item-title">
                        <p>{{ item.title }}</p>
                      </div>
                      <div>
                        <p v-html="item.content"></p>
                      </div>
                      <div v-if="item.base64image" class="extra-info-img">
                        <img
                          class="non-gallery-img"
                          :src="item.base64image"
                          alt="accordion image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VouchersModal 
      ref="VouchersModalRef"
      :item="item"
      :voucherInformation="voucherInformation"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VouchersModal from "@/partials/extra-info-buttons/vouchers";
import {
  fetchVoucherRecord,
  fetchVoucherInformation,
} from "../../../../../partials/extra-info-buttons/services";
import ViewVoucherButton from "./viewVoucherButton.vue";

export default {
  components: {
    ViewVoucherButton,
    VouchersModal
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    booking: {
      type: Object,
      default: null,
    },
    param: {
      type: String,
      required: true,
    },
    voucherEssential: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dropdown: false,
      filenames: [],
      viewVoucher: false,
      viewTFVoucher: false,
      viewBedsOnlineVoucher: false,
      viewViatorVoucher: false,
      viewMultiple: false,
      viewAdditional: false,
      viewVoucherInfo: false,
      viewEssentialInfo: false,
      viewError: false,
      scrollToAdditionalDocs: false,
      voucherSuppliers: [],
      voucherInformation: "",
    };
  },
  computed: {
    ...mapGetters({
      fil: "booking/getFil",
      itineraryRaw: "booking/getItineraryRaw",
      essInfo: "booking/getEssentialInfo",
      additionalSupDocIndexes: "booking/checkForAdditionalSupDocs",
      sessionNum: "booking/getSessionID",
    }),
    returnHeadingIcon() {
      // Return correct image code based on the type of tour, found via the brick id
      if (this.item.brickid === "1") {
        return '<i class="icon-cruise vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("CRUISE HOLIDAY")
      ) {
        return '<i class="icon-cruise vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("SAFARI")
      ) {
        return '<i class="icon-safari vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("GROUP")
      ) {
        return '<i class="icon-small_group_tour vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("MULTI CENTRE")
      ) {
        return '<i class="icon-trail_notes vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        (this.item.brickid === "2" && this.item.tourtype.includes("RAIL")) ||
        this.item.jsontype === "rail"
      ) {
        return '<i class="icon-rail vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("TRAVEL PASS")
      ) {
        return '<i class="icon-travel_pss vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("VOLUNTEER PROJECT")
      ) {
        return '<i class="icon-volunteer_project vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("WORK ABROAD")
      ) {
        return '<i class="icon-work_abroad vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("SKILL")
      ) {
        return '<i class="icon-learn_a_skill vtd-icon-4 glyph-lg vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("WILDERNESS")
      ) {
        return '<i class="icon-wilderness_experience vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (this.item.tourtype.includes("ATTRACTION TICKETS")) {
        return '<i class="icon-event_tickets vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("ADVENTURE TOUR")
      ) {
        return '<i class="icon-trail_notes vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("ESCORTED TOUR")
      ) {
        return '<i class="icon-escorted_tour vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("CRUISE LAND TOUR")
      ) {
        return '<i class="icon-cruise vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (this.item.brickid === "2") {
        return '<i class="icon-accomodation vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (this.item.brickid === "3") {
        return '<i class="icon-private_tour vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (this.item.brickid === "4" && this.item.tourtype.includes("EVENT")) {
        return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>theaters</span></i>';
      } else if (
        this.item.brickid === "4" &&
        this.item.tourtype.includes("LOCAL TOUR")
      ) {
        // check if local tour_style exists
        if (this.item.tour_details && this.item.tour_details.tour_style) {
          if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("CRUISE") ||
            this.item.tour_details.tour_style.toUpperCase().includes("FERRY")
          ) {
            return '<i class="icon-cruise vtd-icon-4 glyph-lg vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("GROUP")
          ) {
            return '<i class="icon-small_group_tour vtd-icon-4 glyph-lg vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("RAIL")
          ) {
            return '<i class="icon-rail vtd-icon-4 glyph-lg vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("SCENIC FLIGHT")
          ) {
            return '<i class="icon-flight vtd-icon-4 glyph-lg vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("ATTRACTION TICKETS")
          ) {
            return '<i class="icon-event_tickets vtd-icon-4 glyph-lg vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("COACH")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>directions_bus</span></i>';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("CYCLING")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>pedal_bike</span></i>';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("SKI LIFT")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>downhill_skiing</span></i>';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("SHUTTLE")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>airport_shuttle</span></i>';
          } else if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("ARRIVAL PACK")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>inventory</span></i>';
          } else {
            return '<i class="icon-local_tour vtd-icon-4 glyph-lg vtd-align-middle" />';
          }
        } else {
          return '<i class="icon-local_tour vtd-icon-4 glyph-lg vtd-align-middle" />';
        }
      } else if (this.item.brickid === "4" && this.item.tourtype === "FERRY") {
        return '<i class="icon-ferry glyph-lg pr-3"/>';
      }
      if (
        this.item.brickid === "5" &&
        this.item.tourtype === "WEDDING PACKAGE"
      ) {
        return '<i class="icon-wedding_package vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      if (
        this.item.brickid === "5" &&
        this.item.tourtype !== "WEDDING PACKAGE"
      ) {
        return '<i class="icon-wedding_package vtd-icon-4 glyph-lg vtd-align-middle" />';
      }
      return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>info</span></i>';
    },
    getParam(){
      return this.param
    }
  },
  filters: {
    replaceFilename: (value) => {
      if (value) {
        value = value.replace(/_/g, " ");
        value = value.substring(0, value.indexOf("."));
        return value;
      }
      return "";
    },
  },
  async created() {
    if (this.item.essentialInformation.voucherEssential.length > 0) {
      for (const element of this.item.essentialInformation.voucherEssential) {
        if (element.suppliers) {
          const sup = await fetchVoucherRecord(element._id, this.sessionNum);
          this.voucherSuppliers.push({ ...sup });
        }
      }
    }
  },
  mounted() {
    if (this.expanded) {
      if (this.viewMultiple) {
        this.filenames = this.item.supdocslist.map(
          (index) => this.essInfo.supplier_documents.filenames[index]
        );
        this.dropdown = true;
      }
      if (this.viewEssentialInfo || this.voucherInformation) {
        this.dropdown = true;
      }
    }
  },
  watch: {
    expanded: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.dropdown = true;
        } else {
          this.dropdown = false;
        }
      },
    },
  },
  methods: {
    openVoucher(flag, vouchno, index) {
      let extension = "";
      if (flag === "supplier") {
        extension = this.essInfo.supplier_documents.filenames[index].replace(
          " ",
          "%20"
        );
      }
      setTimeout(() => {
        if (flag === "tf") {
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/travel-vouchers/${this.booking.user_information.bookingNumber}_${vouchno}.pdf`,
            "_blank"
          );
        } else if (flag === "bedsonline") {
          const param = vouchno.replace(/^BEDSONLINE-/, "");
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/tourdoc/bedsonline/${param}.pdf`,
            "_blank"
          );
        } else if (flag === "viator") {
          const param = vouchno.replace(/^VIATOR-/, "");
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/tourdoc/viator/${param}.pdf`,
            "_blank"
          );
        } else {
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/tourdoc/bybookno/${this.booking.user_information.bookingNumber}/${extension}`,
            "_blank"
          );
        }
      }, 500);
    },
    openMultipleVouchers() {
      this.filenames = this.item.supdocslist.map(
        (index) => this.essInfo.supplier_documents.filenames[index]
      );
      this.dropdown = !this.dropdown;
    },
    openEssentialInfo() {
      if (this.voucherEssential) {
        this.dropdown = !this.dropdown;
      }
    },
    async openNewVoucherModal(string) {
      const data = await fetchVoucherInformation(string);
      if (data) {
        this.voucherInformation = data;
        this.$refs.VouchersModalRef.show();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
